export const FETCH_UPDATE_USER_BY_USER_ID_REQUEST = 'FETCH_UPDATE_USER_BY_USER_ID_REQUEST'
export const FETCH_UPDATE_USER_BY_USER_ID_SUCCESS = 'FETCH_UPDATE_USER_BY_USER_ID_SUCCESS'
export const FETCH_UPDATE_USER_BY_USER_ID_FALUIRE = 'FETCH_UPDATE_USER_BY_USER_ID_FALUIRE'
